module.exports = __webpack_public_path__ + "img/tel.24d45ad6.svg";